angular.module('GlobalHelpersModule').filter "daysAgo", ->
  (date) ->
    if date? and date.length > 0 then moment(date).fromNow() else ""